export const RmsColors = {
  RMS_DARK_PRIMARY_COLOR: '#102638',
  RMS_LIGHTEN_PRIMARY_COLOR: '#033C59',
  RMS_LIGHTER_PRIMARY_COLOR: '#04496C',
  RMS_PRIMARY_COLOR: '#35B776',
  RMS_TEAL_COLOR: '#2480E6',
  GREY_MED: '#929292',
  GREY_BG: '#CCCCCC',
  GREY_LIGHT: '#EBEDEE',
  RMS_INFO_COLOR: '#4A91DD',
  RMS_GRAY_DETAIL: '#E1E2E5',
  RMS_DANGER_COLOR: '#F00',
  RMS_INACTIVE_COLOR: '#C00',
  RMS_SHARK: '#2F3137',
  RMS_LIGHT_HIGHLIGHT: '#E7F6F9',
  RMS_TABLE_TH_COLOR: '#303137',
  RMS_TABLE_ACTIVE_TH_COLOR: '#CED4DA',
  RMS_PAGE_BKG_COLOR: '#EEEFF2',
  RMS_SUBHEADER_PAGE_BKG_COLOR: '#F8F8FA',
  RMS_BORDER_COLOR: '#E9ECEF',
  RMS_OVERVIEW_RAVEN_COLOR: '#6C757D',
  RMS_DARK_GRAY: '#333333',
  RMS_PROFILE_IMG_COLOR: '#A1C34759',
  RMS_TABLE_DIVIDER_COLOR: '#D2D2D2',
  RMS_DIVIDER_COLOR: '#D1D3D4',
  RMS_NOTIFICATION_GREEN: '#9EBE61',
  RMS_NOTIFICATION_LINK: '#3B3B3B',
  RMS_ORANGE: '#F79B41',
  RMS_COMPANY_HEADER_BG_COLOR: '#D7D9DC',
  RMS_COMPANY_BORDER: '#CFD1D5',
  TABLE_BORDER_COLOR: '#DEE2E6',
  RMS_CANCEL_GRAY_COLOR: '#959BA6',
  RMS_CRM_DETAILS_COLOR: '#417EDF',
  RMS_SUCCESS_ALTERNATIVE: '#94C647',
  RMS_ERROR_ALTERNATIVE: '#CF002D',
  RMS_WARNING_ALTERNATIVE: '#FA9641',
  RMS_TOOLTIP_BORDER: '#A9D8F0',
  RMS_CRM_WARNING: '#9F3E52',
  RMS_DOMAIN_COMMERCIAL: '#953648',
  RMS_DOMAIN_HTS: '#C76C12',
  RMS_DOMAIN_ONCOLOGY: '#653F9D',
  RMS_DOMAIN_GENMED: '#2175E2',
  RMS_DOMAIN_INFECT: '#73B905',
  RMS_DOMAIN_GRAY: '#9C9C9C',
  RMS_DOMAIN_BADGE_COMMERCIAL_FONT: '#9F3E52',
  RMS_DOMAIN_BADGE_HTS_FONT: '#CE7711',
  RMS_DOMAIN_BADGE_ONCOLOGY_FONT: '#7048A7',
  RMS_DOMAIN_BADGE_GENMED_FONT: '#2480E6',
  RMS_DOMAIN_BADGE_INFECT_FONT: '#68A800',
  RMS_DOMAIN_BADGE_COMMERCIAL_BG_COLOR: '#9F3E521A',
  RMS_DOMAIN_BADGE_HTS_BG_COLOR: '#CE77111A',
  RMS_DOMAIN_BADGE_ONCOLOGY_BG_COLOR: '#7048A71A',
  RMS_DOMAIN_BADGE_GENMED_BG_COLOR: '#2480E61A',
  RMS_DOMAIN_BADGE_INFECT_BG_COLOR: '#68A8001A',
  RMS_HARD_TO_BORROW: '#BC4141',
  GREY_DARKER: '#3F4149',
  GREY_DARK: '#59595A',
  GREY_TEXT: '#4C4C4C',
  GREY_BLUE: '#314052',
  GREY_LIGHT_BLUE: '#515867',
  GREY_LT: '#E0E0E1',
  GREY_ASH: '#F5F5F6',
  GREY_TUNA: '#303137',
  GREY_GULL: '#9EA5B7',
  GREY_SHARK: '#222329',
  GREY_BOMBAY: '#AEAFB2',
  GREY_IRON: '#E2E3E4',
  GREY_DIVIDER: '#CFD1D5',
  GREY_SHOW_MORE_HOVER: '#F1F3F4',
  RED_ALERT: '#FB1C25',
  RED_LT: '#BD301F',
  RED_XFORM: '#ED584F',
  GREEN_SPRING: '#7EC943',
  DARK_GREEN: '#68A800',
  ORANGE_WARNING: '#FC9909',
  LIGHT_ORANGE: '#FFA827',
  BLUE: '#31708F',
  DARK_BLUE: '#517A92',
  SELECT_CARET_COLOR: '#60666B',
  BLACK: '#000',
  WHITE: '#FFF',
  PIVOTAL_COLOR: '#54C2C3',
  MAJOR_COLOR: '#F7983B',
  STRUCT_CAP_PRIMARY_COLOR: '#68A800',
};
